ui-cms-company-logos-footer {
  display: flex;
  flex-wrap: wrap;
  gap: $sd-spacing-5;

  img {
    max-width: 100%;
  }

  &.size--small img {
    height: $sd-spacing-8;
  }

  &.size--medium img {
    height: $sd-spacing-10;
  }
}
